import React from 'react';
import MainSearch from '../MainSearch/MainSearch';
import ChatsListItem from '../ChatsListItems/ChatsListItems';
import './Chats.css';

const MainChats = () => {
  return (
    <section className="chatscontainer">
      <MainSearch />
      <div className="chatsitemscontainer">
        <ChatsListItem available badge username="#simplytolz" />
        <ChatsListItem badge username="#mplytolz" />
        <ChatsListItem available badge username="#mplytolz" />
        <ChatsListItem badge username="#mplytolz" />
        <ChatsListItem badge username="#mplytolz" />
        <ChatsListItem badge username="#mplytolz" />
        <ChatsListItem badge username="#mplytolz" />
        <ChatsListItem badge username="#mplytolz" />
        <ChatsListItem badge username="#mplytolz" />
      </div>
    </section>
  );
};

export default MainChats;
